export const getSortLabel = (sortId, options) => {
	return options.find(option => option.id === sortId)?.label;
};
